<p-toast></p-toast>

<div style="display: flex; flex-direction: row;">
  <div>
    <!-- Left side -->
    <p-card styleClass="card">
      <ng-template pTemplate="header">
        <p-toolbar>
          <div class="p-card-title">
            {{'CUSTOMERLIST' | translate}}
          </div>
          <div>
            <p-button icon="pi pi-plus-circle" styleClass="p-button-primary" class="mr-2" (click)="openDialog('import')" label="{{'IMPORTCUSTOMER' | translate}}"></p-button>
            <p-button icon="pi pi-plus-circle" styleClass="p-button-primary" (click)="openDialog('customer')" label="{{'NEWCUSTOMER' | translate}}"></p-button>
            <p-button icon="pi pi-download" styleClass="p-button-secondary" class="mr-2" (click)="exportSelectedCustomers()" [disabled]="!selectedCustomers || !selectedCustomers.length" label="{{ 'GENERIC.EXPORT' | translate }}"></p-button>
            <p-button icon="pi pi-trash" styleClass="p-button-danger" class="mr-2" (click)="deleteSelectedCustomers()" [disabled]="!selectedCustomers || !selectedCustomers.length" label="{{ 'GENERIC.DELETE' | translate }}"></p-button>
          </div>
        </p-toolbar>
      </ng-template>
      <!-- Custoemr Table (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" [(selection)]="customer" -->
      <p-table #dt1 [value]="customers | async" [(selection)]="selectedCustomers" dataKey="id" [rows]="10" [rowHover]="true" [globalFilterFields]="['name', 'customerNo', 'addressSearch']" styleClass="p-datatable-gridlines" scrollHeight="500px"
               selectionMode="multiple" responsiveLayout="scroll" [loading]="loading">
        <ng-template pTemplate="caption">
          <div class="flex justify-content-between flex-column sm:flex-row">
            <span class="p-input-icon-left mb-2">
              <i class="pi pi-search"></i>
              <input pInputText type="text" #filter (input)="dt1.filterGlobal($event.target.value, 'contains')" placeholder="{{'GENERIC.SEARCH' | translate}}" class="w-full" />
            </span>
          </div>
        </ng-template>

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
            <th pSortableColumn="customerNo">
              <div class="flex justify-content-between align-items-center">
                {{'CUSTOMERNO' | translate}} <p-sortIcon field="customerNo"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="name">
              <div class="flex justify-content-between align-items-center">
                {{'NAME' | translate}} <p-sortIcon field="name"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="Addrese">
              <div class="flex justify-content-between align-items-center">
                {{'ADDRESSE' | translate}} <p-sortIcon field="Addrese"></p-sortIcon>
              </div>
            </th>
            <th pSortableColumn="ZipCode">
              <div class="flex justify-content-between align-items-center">
                {{'ZIPCODE' | translate}} <p-sortIcon field="zipcode"></p-sortIcon>
              </div>
            </th>

            <th pSortableColumn="City">
              <div class="flex justify-content-between align-items-center">
                {{'CITY' | translate}} <p-sortIcon field="city"></p-sortIcon>
              </div>
            </th>

            <th class="flex justify-content-center align-items-center text-center">
              {{'GENERIC.DELETE' | translate}}
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-customer>
          <tr (click)="onCustomerClick(customer)">
            <td (click)="$event.stopPropagation()">
              <p-tableCheckbox [value]="customer" />
            </td>
            <td style="min-width: 12rem;"> {{customer.customerNo}} </td>
            <td style="min-width: 12rem;"> {{customer.name}} </td>

            <td class="text-center">
              {{customer.customerAddrses?.length > 0 ? customer.customerAddrses[0]?.street : ''}}
            </td>
            <td class="text-center">
              {{customer.customerAddrses?.length > 0 ? customer.customerAddrses[0]?.zipCode : ''}}
            </td>
            <td class="text-center">
              {{customer.customerAddrses?.length > 0 ? customer.customerAddrses[0]?.city : ''}}
            </td>

            <td class="text-center">
              <i class="pi pi-trash" style="color:#fc6161;" (click)="deleteCustomer($event,customer)"></i>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="2">{{'NOCUSTOMERSFOUNDMESSAGE' | translate}}</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
          <tr>
            <td colspan="2">{{'FETCHINGCUSTOMERSMESSAGE' | translate}}</td>
          </tr>
        </ng-template>
      </p-table>
    </p-card>
  </div>
  <!-- Rigth Side -->
  <div style="width: 100%; padding-left: 5px;">
    <p-card styleClass="card" *ngIf="customer">

      <!-- <header>
        <h6>{{('NAME' | translate) +': ' + tmpCustomerName}}</h6>
        <h6>{{('CUSTOMERNO' |translate) + ': ' + tmpCustomerNo }}</h6>
      </header> -->

      <div style="display: flex; flex-direction:column; justify-content: start start; gap:15px; width: 50%;">

        <div style="display: flex; flex-direction: row; gap:15px; align-content: start;">

          <p-floatLabel>
            <input pInputText id="customerNo" [(ngModel)]="tmpCustomerNo" type="text" />
            <label for="customerNo">{{'CUSTOMERNO' | translate}}</label>
          </p-floatLabel>

          <p-floatLabel>
            <input pInputText [(ngModel)]="tmpCustomerName" type="text" />
            <label>{{'NAME' | translate}}</label>
          </p-floatLabel>
        </div>

        <div style="display: flex; flex-direction: row; gap:15px; align-content: start;">

          <p-floatLabel>
            <textarea rows="4" pInputTextarea [(ngModel)]="tmpCustomerNote"></textarea>
            <label>{{'NOTE' | translate}}</label>
          </p-floatLabel>

          <div style="display: flex; flex-direction: column; gap: 0.75rem; width: 100%; min-width: 400px;">

            <p-floatLabel>
              <p-multiSelect [options]="clientServices" [(ngModel)]="tmpCustomerServiceCodes" optionLabel="name" optionValue="code" [showClear]="true" [style]="{ width: '50%' }">
              </p-multiSelect>
              <label>{{ 'CUSTOMERSERVICESLIST' | translate }}</label>
            </p-floatLabel>

            <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; min-height: 2rem;">
              <p-chip *ngFor="let service of selectedServices" [label]="service.name | translate" [removable]="true" (onRemove)="removeService(service.code)">
              </p-chip>
            </div>

          </div>

        </div>

      </div>
      <div>

      </div>
      <!-- <div style="padding-top: 15px;">
        <button pButton pRipple icon="pi pi-save" tooltipPosition="left" (click)="updateCustomer()" pTooltip="{{'SAVECUSTOMER' | translate}}" class="p-button-rounded p-button-success"></button>
      </div> -->

      <div style="flex-direction: column; gap: 15px; padding-top: 15px;">
        <!-- Addrese table -->
        <p-panel header="{{ 'CUSTOMER.DETAILS.ADDRESSES' | translate }}" [toggleable]="true">
          <div style="padding-bottom: 15px;">

            <button pButton pRipple label="{{ 'GENERIC.ADD' | translate }}" icon="pi pi-plus"
                    class="p-button-success mr-2" (click)="openDialog('address')"></button>
            <button pButton pRipple label="{{ 'GENERIC.DELETE' | translate }}" icon="pi pi-trash"
                    class="p-button-danger" (click)="deleteSelectedAddresses()" [disabled]="!selectedAddresses || !selectedAddresses.length"></button>
          </div>

          <!-- <p-toolbar styleClass="mb-4 gap-2">
            <ng-template pTemplate="left">

            </ng-template>
          </p-toolbar> -->

          <!-- addresess table-->
          <p-table #addressTable [value]="customer.addresses" dataKey="id" [rowHover]="true" selectionMode="multiple" [(selection)]="selectedAddresses" [loading]="addressesLoading">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 4rem"> <p-tableHeaderCheckbox></p-tableHeaderCheckbox> </th>
                <th>
                  <div class="flex justify-content-between align-items-center"> {{ 'CUSTOMER.ADDRESS.STREET' | translate }} </div>
                </th>
                <th>
                  <div class="flex justify-content-between align-items-center"> {{ 'CUSTOMER.ADDRESS.ZIPCODE' | translate }} </div>
                </th>
                <th>
                  <div class="flex justify-content-between align-items-center"> {{ 'CUSTOMER.ADDRESS.CITY' | translate }} </div>
                </th>
                <th>
                  <div class="flex justify-content-between align-items-center"> {{ 'CUSTOMER.ADDRESS.COUNTRY' | translate }} </div>
                </th>
                <th>{{'GENERIC.DELETE' | translate}}</th>
                <th>{{'GENERIC.EDIT' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-address>
              <tr>
                <td> <p-tableCheckbox [value]="address"></p-tableCheckbox> </td>
                <td> {{ address.street }} </td>
                <td> {{ address.zipCode }} </td>
                <td> {{ address.city }} </td>
                <td> {{ 'COUNTRIES.'+address.countryCode | translate }} </td>
                <td> <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger" (click)="deleteAddress(address)"></button> </td>
                <td> <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-info" (click)="openDialog('address', address)"></button> </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>

        <!-- Contact Person table-->
        <p-panel header="{{ 'CUSTOMER.DETAILS.CONTACTPERSONS' | translate }}" #contactPersonPanel [toggleable]="true">

          <div style="padding-bottom: 15px;">
            <button pButton pRipple label="{{ 'GENERIC.ADD' | translate }}" icon="pi pi-plus"
                    class="p-button-success mr-2" (click)="openDialog('contactPerson')"></button>
            <button pButton pRipple label="{{ 'GENERIC.DELETE' | translate }}" icon="pi pi-trash"
                    class="p-button-danger" (click)="deleteSelectedContacts()"
                    [disabled]="!selectedContactPersons || !selectedContactPersons.length"></button>

          </div>

          <p-table #contactsTable [value]="customer.contactPersons" dataKey="id" [rowHover]="true"
                   selectionMode="multiple" [(selection)]="selectedContactPersons">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 4rem">
                  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th>
                  <div class="flex justify-content-between align-items-center">
                    {{ 'CUSTOMER.CONTACT.NAME' | translate }}
                  </div>
                </th>
                <th>
                  <div class="flex justify-content-between align-items-center">
                    {{ 'CUSTOMER.CONTACT.EMAIL' | translate }}
                  </div>
                </th>
                <th>
                  <div class="flex justify-content-between align-items-center">
                    {{ 'CUSTOMER.CONTACT.PHONE' | translate }}
                  </div>
                </th>
                <th>
                  <div class="flex justify-content-between align-items-center">
                    {{ 'CUSTOMER.CONTACT.SENDLABEL' | translate }}
                  </div>
                </th>
                <th>{{'GENERIC.DELETE' | translate}}</th>
                <th>{{'GENERIC.EDIT' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-contact>
              <tr>
                <td>
                  <p-tableCheckbox [value]="contact"></p-tableCheckbox>
                </td>
                <td>
                  {{ contact.name }}
                </td>
                <td>
                  {{ contact.email }}
                </td>
                <td>
                  {{ contact.phone }}
                </td>
                <td>
                  {{contact.sendLabel ? ('GENERIC.YES' | translate) : ('GENERIC.NO' | translate)}}
                </td>
                <td>
                  <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                          (click)="deleteContact(contact)"></button>
                </td>
                <td>
                  <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-info"
                          (click)="openDialog('contactPerson', contact)"></button>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-panel>
      </div>
      <div style="padding-top: 5px;">
        <button pButton pRipple tooltipPosition="left" (click)="updateCustomer()" pTooltip="{{'SAVECUSTOMER' | translate}}">{{'GENERIC.SAVE' | translate}}</button>
      </div>
    </p-card>
  </div>
</div>

<p-confirmDialog></p-confirmDialog>
<div class="spinner-overlay" *ngIf="fullPageLoading">
  <p-progressSpinner styleClass="w-8rem h-8rem" strokeWidth="6" animationDuration="1s"></p-progressSpinner>
  <br />
  <p>{{'FETCHINGCUSTOMERS' | translate }}</p>
</div>

<p-confirmDialog key="deleteCustomer"></p-confirmDialog>